import * as ArticlesShared from "./Articles/ArticlesShared.js";
import * as CategoryManagement from "./Articles/CategoryManagement.js";
import * as EditArticle from "./Articles/EditArticle.js";
import * as ViewArticlesPaging from "./Articles/ViewArticlesPaging.js";
import UserPrefs from "./UserPrefs";
import TrailingIndex from "./trailingIndex";
import SideNav from "./sidenav";
import SearchUtils from "./SearchUtils";
import WageLossCalc from "./WageLossCalc"
import * as Utils from "./utils";

var userPrefs = new UserPrefs();
var trailingIndex = new TrailingIndex();
var sideNav = new SideNav();
var wageLossCalc = new WageLossCalc();

var metrics = {};
var scrollOffset = 0;

var container = document.getElementById("outer");
var bar = document.getElementById("main-nav");

$(document).ready(function () {
  // Articles
  var pageNumber = ViewArticlesPaging.getParameterByName("pageNumber", 0);
  if (pageNumber != 0) {
    ViewArticlesPaging.loadArticlePage(null, pageNumber);
  } else {
    ViewArticlesPaging.loadInitialPaging(false);
  }
  var licenseKey = $("#licenseKey").val();
  var editor = new FroalaEditor("#froala-editor", { key: licenseKey });

    Utils.ObfuscateApaMailTags();

    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('feedback') && urlParams.get('feedback')=='true') {
        $('#profile-modal').modal('show');
    }

    if (userPrefs != null) {
        //NC - 09142023 - if the "model" value is null then the UserPref.js isn't loaded with UserPrefCookie settings try reinitializing it.
        // We have to figure out the root cause why UserPref.js is loaded with no cookie value
        // This happens only for the user with E accounts not D or for users who don't have access to sitecore content.
        if (userPrefs.model == null) {
            userPrefs = new UserPrefs();
        }
        userPrefs.onReadyEvents();
        if (userPrefs.model?.home.bookmarkedToolsIds) {
            userPrefs.setupBookmark(userPrefs.model.home.bookmarkedToolsIds);
            if (userPrefs.model.home.iconZoomLevel) {
                loadZoomLevel(userPrefs.model.home.iconZoomLevel);
            } else {
                loadZoomLevel(1);
            }
        
        }
  }
    loadDefaults();

    trailingIndex.onReadyEvents();
    wageLossCalc.onReadyEvents();
    sideNav.onReadyEvents();

    if ($('#widgets').length) {
        $("#widgets").sortable(
            {
                items: 'li[id!=add-icons]',
                update: function () {
                    userPrefs.clearBookmarkedToolsIds();
                    var lis = document.getElementById('widgets').getElementsByTagName('li');
                    // -1 do not include add icon button
                    for (var counter = 0; counter < lis.length -1; counter++) {
                        userPrefs.addToolWithoutPost(lis[counter].id.replace('Tool-', ''));
                    }
                    userPrefs.postPrefs();
                    $(".icons").addClass("edit");   // make sure we stay in edit mode
                    $("#Search-Engine .icons span").removeClass("d-none");
                }
            }
        );
        $("#widgets").disableSelection();

        $('body').click(function (event) {
            // if they click on another button stay in edit mode
            if (event.target.closest('li') != null) {
                return;
            }            
            $(".icons.edit span").addClass("d-none");
            $(".icons.edit").removeClass("edit");     
        });
    }
    //need this method for the 3rd option to pre-process before other click handlers
    document.addEventListener('click', handler, true);
    document.addEventListener('change', handler, true);    

    //make sure icons are block cleared and ready
    $(".widget-icons").removeClass("race-block");
    $("#iconZoomSelector").removeClass("race-block");

    // always reset the modal on close to prevent user block outs
    $("#widget-modal").on('hide.bs.modal', function () {
        $(".widget-icons").removeClass("race-block");
        $("#iconZoomSelector").removeClass("race-block");
    });

    container = document.getElementById("outer");
    bar = document.getElementById("main-nav");

    setMetrics(); 

    document.getElementsByClassName("toggleRight")[0].addEventListener("click", function (e) {
        e.preventDefault()
        doSlide("right")
    });

    document.getElementsByClassName("toggleLeft")[0].addEventListener("click", function (e) {
        e.preventDefault()
        doSlide("left")
    });      

    window.addEventListener("resize", function () {
        // reset to left pos 0 on window resize
        adjust();
    });

    window.onload = function () {
        if ($('.nav-item.active').length > 0) {
            var amountToScroll = 0;
            setMetrics();
            amountToScroll = $('.nav-item.active').position().left;
            if (amountToScroll < 280) {
                return;
            }
            if (Math.abs(amountToScroll) >= metrics.bar - Math.abs(bar.offsetLeft) - metrics.container) {
                amountToScroll = -(metrics.bar - Math.abs(bar.offsetLeft) - metrics.container) + bar.offsetLeft;
            }
            // value should always be neg to scroll to the right
            if (amountToScroll > 0) {
                amountToScroll = amountToScroll * -1;
            }
            bar.style.left = amountToScroll + "px";
            setMetrics();
        }
    };  

    $(document).delegate("#main-nav", {
        'touchstart': function (e) {
            window.firstTouch = e.originalEvent.touches[0].pageX || e.originalEvent.changedTouches[0].pageX;
        },
        'touchmove': function (e) {
            var amountToScroll = 0;
            var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
     
            if ((firstTouch > touch.pageX)) {
                if ((Math.abs(bar.offsetLeft)) + metrics.container > metrics.bar && metrics.container != 0) {                
                    return;
                }
                amountToScroll = -(Math.abs(bar.offsetLeft) + Math.min((firstTouch - touch.pageX), 50));
                if (Math.abs(amountToScroll) >= metrics.bar - Math.abs(bar.offsetLeft) - metrics.container) {
                    amountToScroll = -(metrics.bar - Math.abs(bar.offsetLeft) - metrics.container) + bar.offsetLeft;
                }
            }
            else {
                amountToScroll = Math.min(0, (metrics.container + metrics.left));
            }

            bar.style.left = amountToScroll + "px";
                        
            setTimeout(function () {
                setMetrics();
            }, 400)
        }
    });

    if($('ul#main-nav li').length <= 2) {
        $('#outer').hide();
        $('#main-nav').hide();
        $('.paddle').hide();
    }
    if ($('ul#main-nav li').length < 3) {        
        $('.paddle').hide();
    }

 });

function handler(event) {
    if (event.target.parentNode.className.includes("race-block") ||
        event.target.className.includes("race-block")) {
        event.stopPropagation();
        event.preventDefault();
        return false;
    }   

}

$('[data-spy="scroll"]').on("activate.bs.scrollspy", function () {
  var container = $(".apa-manual-nav");
  var scrollTo = $(".active");
  // Calculating new position of scrollbar
  var position =
    scrollTo.last().offset().top -
    container.offset().top +
    container.scrollTop() -
    50;
  // Setting the value of scrollbar
  container.scrollTop(position);
});

window.addEventListener("load", function () {
  $("#main-content").css("display", "block");
});

var defaultOpen = document.getElementById("defaultOpen");
if (defaultOpen != null) {
  defaultOpen.click();
}


function setMetrics() {
    metrics = {
        bar: bar.scrollWidth || 0,
        container: container.clientWidth || 0,
        left: parseInt(bar.offsetLeft),
        getHidden() {
            return (this.bar + this.left) - this.container
        }
    }

    updateArrows();
}

function doSlide(direction) {
    setMetrics();
    var amountToScroll = 0;
    var pos = metrics.left;
    if (direction === "right") {
        amountToScroll = -(Math.abs(pos) + Math.min(metrics.getHidden(), metrics.container));
    }
    else {
        amountToScroll = Math.min(0, (metrics.container + pos));
    }
    bar.style.left = amountToScroll + "px";
    setTimeout(function () {
        setMetrics();
    }, 400)
}

function updateArrows() {
    if (metrics.container === 0) {
        document.getElementsByClassName("toggleLeft")[0].classList.add("hide-paddle");
        document.getElementsByClassName("toggleLeftDiv")[0].classList.add("hide-paddle-div");
        document.getElementsByClassName("toggleLeftDiv")[0].classList.remove("paddle-scroll");
        return;
    }      

    if (Math.abs(metrics.left) > metrics.container && metrics.left <= 0 || (Math.abs(metrics.left) + metrics.container == metrics.bar)) {
        document.getElementsByClassName("toggleRight")[0].classList.add("hide-paddle");
        document.getElementsByClassName("toggleRightDiv")[0].classList.add("hide-paddle-div");
        document.getElementsByClassName("toggleRightDiv")[0].classList.remove("paddle-scroll");
    }
    else {
        document.getElementsByClassName("toggleRight")[0].classList.remove("hide-paddle");
        document.getElementsByClassName("toggleRightDiv")[0].classList.remove("hide-paddle-div");
        document.getElementsByClassName("toggleRightDiv")[0].classList.add("paddle-scroll");
    }

    if (metrics.left === 0) {
        document.getElementsByClassName("toggleLeft")[0].classList.add("hide-paddle");
        document.getElementsByClassName("toggleLeftDiv")[0].classList.add("hide-paddle-div");
        document.getElementsByClassName("toggleLeftDiv")[0].classList.remove("paddle-scroll");
    }
    else {
        document.getElementsByClassName("toggleLeftDiv")[0].classList.remove("hide-paddle-div");
        document.getElementsByClassName("toggleLeft")[0].classList.remove("hide-paddle");
        document.getElementsByClassName("toggleLeftDiv")[0].classList.add("paddle-scroll");
    }
}

function adjust() {
    bar.style.left = 0;
    setMetrics();
}



function loadDefaults() {
  //Set Hide tools
  if (userPrefs.model?.home.hideHomeTools != null) {
    if (userPrefs.model.home.hideHomeTools == false) {
      document.getElementById("tools-checkbox").checked = true;
    }
  }

  //if (userPrefs.model?.universal.menuDisplayOption != null) {
    //if (userPrefs.model.universal.menuDisplayOption == "Expanded") {
    //  userPrefs.loadMenuView("menuOverlay");
    //} else {
   userPrefs.loadMenuView("menuSlider");

   if (userPrefs.model?.universal.isMenuOpen === true) {
     $('[data-class="nav-function-fixed"]').click();
     if (userPrefs.model.universal.isMenuMinified === true) {
       setTimeout(function () {
         $('[data-class="nav-function-minify"]').click();
       }, 500);
     } else {
       setTimeout(function () {
         $("#menubtn").click();
       }, 500);
     }
   }
    //}
  //}

  //if (userPrefs.model?.universal.themeColor != null) {
  //  document.getElementById("primary_color").value =
  //    userPrefs.model.universal.themeColor;
  //}

  //Set Dark Mode
  $("#darkmodeicon").addClass("d-flex");
  $("#lightmodeicon").removeClass("d-flex");
  if (userPrefs.model?.universal.darkMode != null) {
    if (userPrefs.model.universal.darkMode == true) {
      //document.getElementById("dark-mode-switch").checked = true;

      $("#lightmodeicon").addClass("d-flex");
      $("#darkmodeicon").removeClass("d-flex");
    }
  }

  if (userPrefs.model?.universal.avatar != null && $("avatar").length != 0) {
    var url =
      "/-/media/AlliedPilots/Member/Avatars/" +
      userPrefs.model.universal.avatar +
      ".png";
    document.getElementById("avatar").src = url;
    document.getElementById("avatar-profile").src = url;
  }
}

var dropdown = document.getElementsByClassName("dropdown-btn");
var i;

for (i = 0; i < dropdown.length; i++) {
  dropdown[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var dropdownContent = this.nextElementSibling;
    if (dropdownContent.style.display === "block") {
      dropdownContent.style.display = "none";
    } else {
      dropdownContent.style.display = "block";
    }
  });
}

var dropdown = document.getElementsByClassName("dropdown-btn-search");
var i;
for (i = 0; i < dropdown.length; i++) {
  dropdown[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var dropdownContent = this.parentNode.nextElementSibling;
    if (dropdownContent) {
      if (dropdownContent.style.display === "block") {
        dropdownContent.style.display = "none";
      } else {
        dropdownContent.style.display = "block";
      }
    }
  });
}

function ToolKit() {
  if ($("#Toolkit").is(":visible")) {
    $("#Toolkit").css({
      display: "none",
    });
  } else {
    $("#Toolkit").css({
      display: "block",
    });
  }
}

$(document).ready(function () {
  $("add-icons").attr("disabled", false);
  $("app-tools").attr("disabled", false);
});
//$("#widget-modal").on("show.bs.modal", function (e) {
//  //perform action when shown
//  $("html").css("overflow", "hidden");
//});
//$("#widget-modal").on("hidden.bs.modal", function (e) {
//  //Perform action when hidden
//  $("html").css("overflow", "auto");
//});





function submitFeedback() {
  var request = {
    UserName: $("#customerName").val(),
    Category: $("#Category").val(),
    Message: $("#customerNote").val(),
  };

  console.log(request);
  $.ajax({
    url: "/AlliedPilots/PostFeedback/PostFeedback",
    datatype: "json",
    type: "POST",
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ model: request }),
    async: true,
    processData: false,
    cache: false,

    success: function (Data) {
      cusid = Data;
    },
    error: function (xhr) {
      //  alert("error");
      return null;
    },
    error: function (exception) {
      // alert('Exeption:' + exception);
      console.log("Ooops", "Exeption:" + exception.responseJSON, "error");
    },
  });
}

//if (document.getElementById("expanded-navMobileSearch") != null) {
//  document.getElementById("expanded-navMobileSearch").onkeydown = function (
//    event
//  ) {
//    if (event.keyCode == 13) {
//      searchMobileRedirect();
//    }
//  };
//}

if (document.getElementById("navMobileSearch") != null) {
  document.getElementById("navMobileSearch").onkeydown = function (event) {
    if (event.keyCode == 13) {
      searchMobileRedirect();
    }
  };
}

$(document).on("keypress", "#navSearch", function (e) {
    collapseSearchbox(e, "#navSearch");
});

export function collapseSearchbox(event, ctrlId = "#searchbox") {
  if (event.keyCode == 13) {
    var navSearch = $(ctrlId).val();
    if (navSearch != "") {
      Utils.pushRecentSearches(navSearch);
      var baseUrl = window.location.origin;
        var searchURL = baseUrl + "/Search/?q=" + encodeURIComponent(navSearch);
      location.href = searchURL;
    }
  }
}

function searchRedirect() {
  var navSearch = $("#navSearch").val();
  if (navSearch != "") {
    Utils.pushRecentSearches(navSearch);
    var baseUrl = window.location.origin;
    var searchURL = baseUrl + "/Search/?q=" + encodeURIComponent(navSearch);
    location.href = searchURL;
  }
}

function searchMobileRedirect() {
    var navSearch = $('#navMobileSearch').val();
    if (navSearch != "") {
        Utils.pushRecentSearches(navSearch);
        var baseUrl = window.location.origin;
        var searchURL = baseUrl + "/Search/?q=" + encodeURIComponent(navSearch);
        location.href = searchURL;
    }
    //var navSearch = $('#expanded-navMobileSearch').val();
    //if (navSearch != "") {
    //    Utils.pushRecentSearches(navSearch);
    //    var baseUrl = window.location.origin;
    //    var searchURL = baseUrl + "/Search/?q=" + encodeURIComponent(navSearch);
    //    location.href = searchURL;
    //}
}





function isDark(color) {
    var match = /rgb\((\d+).*?(\d+).*?(\d+)\)/.exec(color);
    return (match[1] & 255)
        + (match[2] & 255)
        + (match[3] & 255)
        < 3 * 256 / 2;
}


/***********************************************/
/*************** 9.0: Launch Toast *************/
/***********************************************/
function launch_toast(title, icon, bgColor) {
    var x = document.getElementById("toast");
    var p = $('#toast p');
    var span = $('#toast span');
    var bg = $('#toast #img');
    x.className = "show";
    p.html(title);
    span.html(icon);
    bg.css({'background-color': bgColor});
    setTimeout(function () {
        x.className = x.className.replace("show", "");
    }, 3000);
}

function loadZoomLevel(zoomLevel) {
    $(".icons").css("zoom", userPrefs.model.home.iconZoomLevel);
    $("#add-icons").css("zoom", userPrefs.model.home.iconZoomLevel);

    if (navigator.userAgent.includes('Firefox')) {
        $(".icons").css("-moz-transform", 'scale(' + userPrefs.model.home.iconZoomLevel + ')');
        $("#add-icons").css("-moz-transform", 'scale(' + userPrefs.model.home.iconZoomLevel + ')');

        if (zoomLevel > 1) {
            var marginLevel = 10
            if (zoomLevel >= 1.5) {
                marginLevel = 15
            }
            if (zoomLevel > 1.75) {
                $("#widgets p").css("margin-top", marginLevel + 'px');
            }
            $(".icons").css("margin", marginLevel + 'px');
            $("#add-icons").css("margin", marginLevel + 'px');
        }
    }


    var slider = document.getElementById("iconZoomSelector");
    slider.value = zoomLevel;
    var output = document.getElementById("iconZoomValue");
    output.innerHTML = slider.value + ' x'; // Display the default slider value
    // Update the current slider value (each time you drag the slider handle)
    slider.oninput = function () {
        output.innerHTML = this.value + ' x';
    }
}

export {
  ArticlesShared,
  CategoryManagement,
  EditArticle,
  ViewArticlesPaging,
  UserPrefs,
  Utils,
  SearchUtils,
  WageLossCalc
};
